/* Otzera header: steadier dropdowns + drawer utility links. Plain ES5. v33, Oct 2026.
 *
 * Horizon's header menu opens and closes on pointerenter/pointerleave with no grace period,
 * so a slightly curved path from a menu label to its panel closes the panel. This sits in
 * front of those events (window capture phase, ahead of the theme's document-level
 * listeners) and replays them after a short delay:
 *   - leaving an item or panel closes it only if the pointer hasn't come back within CLOSE_MS;
 *   - while a panel is open, another item takes over only once the pointer rests on its label;
 *   - with nothing open, a panel opens after OPEN_MS, so sweeping across the header doesn't flash panels.
 * Touch, keyboard and click behave exactly as before.
 */
(function () {
  if (window.__otzHeader) { return; }
  window.__otzHeader = true;

  var OPEN_MS = 90;
  var SWITCH_MS = 150;
  var CLOSE_MS = 350;

  var replayed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var closeTimer = null;
  var enterTimer = null;
  var pendingLi = null;

  function isMenuItem(el) {
    return el instanceof Element && el.matches('header-menu .menu-list__list-item');
  }

  function isOwn(e) {
    return replayed ? replayed.has(e) : !!e.__otz;
  }

  function activeItem() {
    var items = document.querySelectorAll('header-menu .menu-list__list-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].querySelector('[aria-expanded="true"]')) { return items[i]; }
    }
    return null;
  }

  function hasPanel(li) {
    return !!(li && li.querySelector(':scope > .menu-list__submenu'));
  }

  function replay(li, type) {
    var ev;
    try { ev = new PointerEvent(type, { bubbles: false, pointerType: 'mouse' }); }
    catch (err) { ev = new Event(type, { bubbles: false }); }
    if (replayed) { replayed.add(ev); } else { ev.__otz = true; }
    li.dispatchEvent(ev);
  }

  function cancelEnter() {
    clearTimeout(enterTimer);
    enterTimer = null;
    pendingLi = null;
  }

  function cancelClose() {
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  window.addEventListener('pointerenter', function (e) {
    var li = e.target;
    if (!isMenuItem(li) || isOwn(e) || e.pointerType === 'touch' || e.pointerType === 'pen') { return; }

    cancelClose();
    var current = activeItem();
    if (current === li) { cancelEnter(); return; }

    // Hold the event; replay it if the pointer is still resting on this item.
    e.stopImmediatePropagation();
    cancelEnter();
    pendingLi = li;
    var switching = !!(current && hasPanel(current));
    var check = function () {
      enterTimer = null;
      if (pendingLi !== li) { return; }
      if (!li.matches(':hover')) { pendingLi = null; return; }
      // While another panel is open, only take over once the pointer is on this item's label.
      // Crossing the strip beneath the labels on the way down to an open panel never switches.
      if (switching && !onLabel(li)) { enterTimer = setTimeout(check, 60); return; }
      pendingLi = null;
      replay(li, 'pointerenter');
    };
    enterTimer = setTimeout(check, switching ? SWITCH_MS : OPEN_MS);
  }, true);

  var lastX = -1;
  var lastY = -1;
  document.addEventListener('pointermove', function (e) {
    lastX = e.clientX;
    lastY = e.clientY;
  }, { passive: true, capture: true });

  function onLabel(li) {
    var title = li.querySelector('.menu-list__link-title') || li.querySelector('.menu-list__link');
    if (!title) { return true; }
    var r = title.getBoundingClientRect();
    var pad = 8;
    return lastX >= r.left - pad && lastX <= r.right + pad && lastY >= r.top - pad && lastY <= r.bottom + pad;
  }

  window.addEventListener('pointerleave', function (e) {
    var li = e.target;
    if (!isMenuItem(li) || isOwn(e) || e.pointerType === 'touch' || e.pointerType === 'pen') { return; }

    e.stopImmediatePropagation();
    if (pendingLi === li) { cancelEnter(); }

    cancelClose();
    closeTimer = setTimeout(function () {
      closeTimer = null;
      var current = activeItem();
      if (!current || current.matches(':hover')) { return; }
      if (pendingLi && pendingLi.matches(':hover')) { return; }
      replay(current, 'pointerleave');
    }, CLOSE_MS);
  }, true);

  /* Verify / Contact at the foot of the mobile menu drawer. */
  function addDrawerLinks() {
    var slots = document.querySelectorAll('.menu-drawer__utility-links');
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      if (slot.querySelector('.otz-drawer-utility')) { continue; }
      var wrap = document.createElement('div');
      wrap.className = 'otz-drawer-utility';
      wrap.appendChild(makeLink('/pages/verify', 'Verify a Gemstone', true));
      wrap.appendChild(makeLink('/pages/contact', 'Contact', false));
      slot.insertBefore(wrap, slot.firstChild);
    }
  }

  function makeLink(href, label, withIcon) {
    var a = document.createElement('a');
    a.href = href;
    if (withIcon) {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 16 16');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var p1 = document.createElementNS(ns, 'path');
      p1.setAttribute('d', 'M8 1.2 13.2 3v4.2c0 3.3-2.2 6-5.2 7.6C5 13.2 2.8 10.5 2.8 7.2V3L8 1.2Z');
      p1.setAttribute('fill', 'none');
      p1.setAttribute('stroke', 'currentColor');
      p1.setAttribute('stroke-width', '1.1');
      p1.setAttribute('stroke-linejoin', 'round');
      var p2 = document.createElementNS(ns, 'path');
      p2.setAttribute('d', 'm5.6 8 1.7 1.7 3.2-3.4');
      p2.setAttribute('fill', 'none');
      p2.setAttribute('stroke', 'currentColor');
      p2.setAttribute('stroke-width', '1.1');
      p2.setAttribute('stroke-linecap', 'round');
      p2.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(p1);
      svg.appendChild(p2);
      a.appendChild(svg);
    }
    a.appendChild(document.createTextNode(label));
    return a;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addDrawerLinks);
  } else {
    addDrawerLinks();
  }
  document.addEventListener('shopify:section:load', addDrawerLinks);
  // Horizon re-hydrates the header after load, which can drop injected nodes, so add them again
  // whenever the drawer opens.
  document.addEventListener('toggle', function (e) {
    if (e.target instanceof Element && e.target.matches('.menu-drawer-container')) { addDrawerLinks(); }
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target instanceof Element && e.target.closest('.header__icon--menu')) { setTimeout(addDrawerLinks, 0); }
  }, true);
  window.addEventListener('load', function () { setTimeout(addDrawerLinks, 600); });
})();